import { useCallback } from "react";

import { Alert } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";

import Loader from "../../../common/components/Loader";
import TeamForm from "../components/Team/TeamForm";
import { useGetTeamById } from "../hooks/team.hooks";

const TeamContainter = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation<{
    readOnly: boolean;
    parentId: string;
  }>();

  // Safely extract state with defaults to prevent undefined errors
  const readOnly = location.state?.readOnly ?? false;
  const agencyId = location.state?.parentId;

  const { data, isLoading, error } = useGetTeamById(id);

  // force rerender form with new data
  const UpdateFormRender = useCallback(
    () => (
      <TeamForm agencyId={agencyId} defaultValues={data} readOnly={readOnly} />
    ),
    [data, readOnly]
  );

  if (!id) {
    return <TeamForm agencyId={agencyId} />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    console.log(`Error Fetch Team id => ${id} :`, error.message);
    return (
      <Alert variant="danger">
        Impossible de récupérer les informations de l'équipe.&nbsp; Veuiller
        contacter votre administrateur système.
      </Alert>
    );
  }

  if (!data) {
    return (
      <Alert variant="danger">
        Erreur de récupération des données : Veuillez réessayer ultérieurement.
      </Alert>
    );
  }

  return <UpdateFormRender />;
};

export default TeamContainter;
